module.exports = __webpack_public_path__ + "static/media/for_developers_bg.33605ebc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/for_developers_bg.svg
// module id = 172
// module chunks = 0